"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAllCheckboxes = void 0;
const get_zaraz_1 = require("../helpers/get-zaraz");
/**
 * Set the checkboxStatus status for all purposes in the consent modal at once.
 */
function setAllCheckboxes(checkboxStatus) {
    (0, get_zaraz_1.getZaraz)().consent.setAllCheckboxes(checkboxStatus);
}
exports.setAllCheckboxes = setAllCheckboxes;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2V0LWFsbC1jaGVja2JveGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnNlbnQvc2V0LWFsbC1jaGVja2JveGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG9EQUFnRDtBQUVoRDs7R0FFRztBQUNILFNBQWdCLGdCQUFnQixDQUFDLGNBQXVCO0lBQ3RELElBQUEsb0JBQVEsR0FBRSxDQUFDLE9BQU8sQ0FBQyxnQkFBZ0IsQ0FBQyxjQUFjLENBQUMsQ0FBQztBQUN0RCxDQUFDO0FBRkQsNENBRUMifQ==